export const SEARCH_SIZES = ['small', 'medium'] as const;
export type SearchSize = (typeof SEARCH_SIZES)[number];
